import { IComponentsService} from "../../interfaces/IComponentsService";
import { IComponentGameObject } from "../../interfaces/IComponentGameObject";
import { IComponent } from "../../interfaces/IComponent";
import { TableScreen } from "../screen/TableScreen";
import { Player } from "../player/Player";
import { Card, CardEffect } from "../card/Card";
import { TableStack } from "../cardStack/TableStack";
import { TrumpSuit } from "../state/TableStateMachine";
import { OptionsDataManager } from "../managers/OptionsDataManager";


/**
 * Lets user play card from their hand
 * - Uses TableAI for highlights, enable/disable hand cards..
 * - Is done as soon as enable/disable/highlight is set AND ANY CARD IS CLICKED. Returns clicked card.
 * In terms of AI player, use TableAI to determine which card to play instead
 * 
 * After this completes (TableStateMachine->OnTackComplete), 
 * use DEAL_PLAYER_TO_TABLE to deal chosen card (in props returned by this) to table.
 */
export class CardPlayer
    implements IComponent
{
    private table!: TableScreen;
    // private components!: IComponentsService;
    private inputData: any;

    public Init(go: IComponentGameObject, components: IComponentsService): void
	{
		this.table = go as TableScreen;
		// this.components = components;
	}

    public SetData(inputData: any): void
    {
        this.inputData = inputData;
        // console.log(TaskType[this.inputData.taskType]);
    }

    public GetData(): any
    {
        return this.inputData;
    }

    /**
     * Based on which cards can be played, update card interactivity
     */
    public UpdateCardInteractivity(playableCards: Card[]): void
    {
        // console.log("CardPlayer::Start",this.inputData);
        
        const player: Player = this.table.players.GetPlayerByIndex(this.inputData.playerIndex);
        const playerCards: Card[] = player.cards;
        // console.log(`CardPlayer: playableCards(${this.inputData.playerIndex})=${playableCards.map(card=>card.log())}`);

        // enable playable cards, disable rest
        for (let i: number = 0; i<playerCards.length; i++) {
            const card: Card = playerCards[i];
            let isPlayablePlayerCard: boolean = false;
            for (let j: number = 0; j<playableCards.length; j++) {
                const playableCard: Card = playableCards[j];
                if (card.suit == playableCard.suit && card.rank == playableCard.rank) {
                    // console.log(this.inputData.playerIndex, "enable", card.log());
                    isPlayablePlayerCard = true;
                    card.SetInteractive(true);
                    break;
                }
            }
            if (!isPlayablePlayerCard) {
                // console.log(this.inputData.playerIndex, "disable", card.log());
                card.SetInteractive(false);
            }
        }
    }

    /**
     * Pop playableCards
     * atm also (TODO MOVE TO HighlightSuggestedMove): Highlight and enable
     *           Darken and disable rest
     * 
     this.inputData:
     {
        taskType: TaskTypeBelote.CHOICE_PLAY_CARD, 
        onComplete: this.OnTaskComplete.bind(this),
        playerIndex: curPlayerIndex,
     }

     return: {
        cards: Card[]
     }
     */
    public PopPlayable(playableCards: Card[]): void
    {
        // console.log("CardPlayer::Start",this.inputData);

        const player: Player = this.table.players.GetPlayerByIndex(this.inputData.playerIndex);
        // const playerCards: Card[] = player.cards;
        // // console.log(`CardPlayer: playableCards(${this.inputData.playerIndex})=${playableCards.map(card=>card.log())}`);

        const trumpSuit: TrumpSuit = this.table.GetStateMachine().GetData().trumpSuit;
        const rankLeftToRight: boolean = OptionsDataManager.IsRankLeftToRight();
        const stackLeftToRight: boolean = OptionsDataManager.IsStackLeftToRight();
        player.ReorderCards(
            true, // animate
            trumpSuit, // trumpSuit
            rankLeftToRight, // rankLeftToRight
            stackLeftToRight, // stackLeftToRight
            false, // skipReorder?
            playableCards, // popCards (atm these are p[layableCards, but we need to get TODO suggested subset])
        );
    }

    /**
     * TODO: implement feature (atm duplicate of 'PopPlayable')
     * 
     * Highlights a single card, that is suggested by the AI system that user plays.
     * 
     */
    public HighlightCards(highlightCards: Card[], playerIndex: number = undefined): void
    {
        // console.log("HighlightCards",highlightCards.map(card=>card.log()));
        playerIndex = playerIndex ?? this.inputData.playerIndex;
        const player: Player = this.table.players.GetPlayerByIndex(playerIndex);
        const playerCards: Card[] = player.cards;

        // enable playable cards, disable rest
        for (let i: number = 0; i<playerCards.length; i++) {
            const card: Card = playerCards[i];
            let doHighlightCard: boolean = false;
            for (let j: number = 0; j<highlightCards.length; j++) {
                const highlightCard: Card = highlightCards[j];
                if (card.suit == highlightCard.suit && card.rank == highlightCard.rank) {
                    doHighlightCard = true;
                    card.SetEffect(CardEffect.NONE);
                    break;
                }
            }
            if (!doHighlightCard) {
                card.SetEffect(CardEffect.DARKEN);
            }
        }
    }

    public OnCardClicked(clickedCard: Card, table: TableScreen): void
    {
        // console.log("CardPlayer::OnCardClicked",card.log());

        // kill tweens running on the clicked card (pop card tween wspecially)
        this.table.scene.tweens.killTweensOf(clickedCard);
        
        // disable all cards
        const player: Player = this.table.players.GetPlayerByIndex(this.inputData.playerIndex);
        const playerCards: Card[] = player.cards;
        for (let i:number = 0; i<playerCards.length; i++) {
            const card: Card = playerCards[i];
            card.SetInteractive(false);
            card.SetEffect(CardEffect.NONE);
        }

        // finish task with clicked card
        this.inputData.onComplete(this.inputData.taskType, {card: clickedCard});
    }
}